import React, { useContext, useEffect, useReducer, useState } from 'react';
import MortgageSignInJointAccountPage from 'pages/mortgage/postSignIn/jointAccount';
import VerifyLoanOwnershipPage from 'pages/mortgage/postSignIn/verifyLoanOwnership';
import SignInRedirectPage from 'pages/mortgage/postSignIn/signInRedirect';
import { SignInContext } from 'contexts';
import { useQueryParams } from 'hookrouter';
import { reducer, getNextAction, ACTIONS } from 'reducers/postSignInForMortgage';
import { getGroups, getMemberInfo } from 'api';
import { useApi } from 'hooks';
import { GroupNames, Process } from 'common';
import ErrorPage from 'pages/errorPage';

const PostSignInForMortgagePage = () => {
  // queryparams into global state
  const [queryParams] = useQueryParams();
  console.log('PostSignInForMortgagePage', queryParams);

  const { appId, redirecturl, besloanID } = queryParams;
  const [signInContext] = useContext(SignInContext);
  const accessToken = signInContext;

  // local states
  const [state, dispatch] = useReducer(reducer, {});
  const [name, setName] = useState();
  const [displayHelp, setDisplayHelp] = useState();
  // This state is changed if the user manually navigates into the page
  const [userNavigated, setNavState] = useState();

  // api
  const [getGroupsStatus, callGetGroups] = useApi(getGroups);
  const [getMemberInfoStatus, callGetMemberInfo] = useApi(getMemberInfo);

  /*  
    onpageshow fires when the user navigates to this page
    It does NOT fire when the user is taken here due to natural flow 
    of the sign in process
  */
  window.onpageshow = () => {
    // Set the navState to true if user navigated here manually
    setNavState(true);
  };

  // https://www.robinwieruch.de/react-hooks-fetch-data/
  useEffect(() => {
    const initialize = async () => {
      const jointInfo = await getJointInfo();
      if (!jointInfo) {
        setDisplayHelp(true);
        return;
      }

      setName(jointInfo.name);
      dispatch({ type: ACTIONS.INIT, needJointCheck: jointInfo.needJointCheck, needLoanVerification: !!besloanID });
    };

    initialize();
    // eslint-disable-next-line
  }, []);

  // return undefined if API call failed
  const getJointInfo = async () => {
    const groups = await callGetGroups(accessToken);
    if (!groups) return;

    let needJointCheck = false;
    let name = '';
    if (isOLBAccount(groups)) {
      const memberInfo = await callGetMemberInfo(accessToken);
      if (!memberInfo) return;

      needJointCheck = memberInfo.jointFlag && !isMortgageAccount(groups);
      name = `${memberInfo.first} ${memberInfo.last}`;
    }

    return { needJointCheck, name };
  };

  const isMortgageAccount = (groups) => groups && groups.indexOf(GroupNames.Mortgage) >= 0;
  const isOLBAccount = (groups) => groups && groups.indexOf(GroupNames.OLB) >= 0;

  const PAGES = {
    [ACTIONS.CHECK_JOINT]: (
      <MortgageSignInJointAccountPage name={name} onContinue={() => dispatch({ type: ACTIONS.CHECK_JOINT })} />
    ),
    [ACTIONS.VERIFY_LOAN]: (
      <VerifyLoanOwnershipPage
        accessToken={accessToken}
        loanId={besloanID}
        onContinue={() => dispatch({ type: ACTIONS.VERIFY_LOAN })}
      />
    ),
    [ACTIONS.REDIRECT]: <SignInRedirectPage appId={appId} redirectUrl={redirecturl} accessToken={accessToken} />,
  };

  const isLoading = () => getGroupsStatus.isLoading || getMemberInfoStatus.isLoading;

  const error = () => {
    // If the user navigated here externally, do not display error page
    if (userNavigated) return false;

    let tempError = false;
    if (getGroupsStatus.error) tempError = getGroupsStatus.error;
    if (getMemberInfoStatus.error) tempError = getMemberInfoStatus.error;
    return tempError;
  };

  const displayHelpCheck = () => {
    return displayHelp ? <ErrorPage /> : PAGES[getNextAction(state)];
  };

  // todo: pass array of status to Process instead
  return (
    <Process error={error} isLoading={isLoading}>
      {console.log('postSignIn nextAction:', getNextAction(state))}
      {userNavigated ? window.location.replace(process.env.REACT_APP_HOME_LOAN_URL) : displayHelpCheck()}
      {console.log('User navigated: ', userNavigated)}
    </Process>
  );
};

export default PostSignInForMortgagePage;
